module.exports = __webpack_public_path__ + "media/images/client/favicons/icon-32x32-6add08ad6246e5bb6b76aef7da95f75a.png";